<a class="btn btn-file btn-exportIssuer" data-toggle="dropdown" disabled="isEmpty" [attr.id]="viewCode" nz-dropdown [nzDropdownMenu]="menu">
    <img src="./assets/images/icons/files.svg" title="Tài liệu bổ sung">
    {{documents.length}}
</a>
<nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu nzSelectable>
        <li nz-menu-item *ngFor="let document of documents">
            <div class="d-flex father-items mb-2">
                <button class="btn btn-print" *ngIf="document.type !== 'PHOTO' && !document.photoType">
                    <img [src]="document.icon || './assets/images/icons/files.svg'" width="24" alt="">
                </button>
                <a class="dropdown-item" [href]="document.url" *ngIf="document.type !== 'PHOTO' && !document.photoType">
                    {{document.fileName}}
                </a>
                <a class="dropdown-item" *ngIf="document.type === 'PHOTO' || document.photoType">
                    <img [src]="document.url" height="50" width="50">
                </a>
                <a class="dropdown-item down-item" [href]="document.url">
                    <img src="./assets/images/icons/download.png" title="Tải về" width="23px" height="auto">
                </a>
            </div>
        </li>
    </ul>
</nz-dropdown-menu>